module.exports = __WEBPACK_EXTERNAL_MODULE_241__;


//////////////////
// WEBPACK FOOTER
// external "dashboard-analytics/widgets/livewidget/query/QueryResultData"
// module id = 241
// module chunks = 0